import logUtil from './log-util'

export const SESSION = 'session'
export const LOCAL = 'local'
export const BANNER_DISMISSED_KEY = 'isOutdatedAppsBannerDismissed'
export const INTEGRATION_SELECTION_MAP_KEY = 'integration-selection-map'

class StorageUtil {
  constructor(storageType) {
    if (storageType === SESSION) {
      this.storage = sessionStorage
    } else if (storageType === LOCAL) {
      this.storage = localStorage
    } else {
      throw new Error('Invalid storage type')
    }
  }

  setItem(key, value) {
    try {
      this.storage.setItem(key, value)
    } catch (err) {
      logUtil.error('Error setting item in storage ', err)
    }
  }

  getItem(key) {
    try {
      return this.storage.getItem(key)
    } catch (err) {
      logUtil.error('Error getting item from storage ', err)
      return null
    }
  }

  removeItem(key) {
    try {
      this.storage.removeItem(key)
    } catch (err) {
      logUtil.error('Error removing item from storage ', err)
    }
  }

  clear() {
    try {
      this.storage.clear()
    } catch (err) {
      logUtil.error('Error clearing items from storage ', err)
    }
  }
}

//cleanup on login

export const cleanupOnLogin = () => {
  const localUtil = new StorageUtil(LOCAL)
  //TODO: add integration details clean up (TBD)

  localUtil.removeItem(BANNER_DISMISSED_KEY)
}

export default StorageUtil
